import { createGlobalStyle } from 'styled-components';
import img from './daedalus.jpg';

const StatisticsStyle = createGlobalStyle`
body {
    background: url('${img}') no-repeat center center fixed;
    background-size: cover;
    font-family: Arial, sans-serif;
    background-color: #0a0a0a;
    color: #87CEFA;
    font-size: 18px;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;
    min-height: 100vh;
}

/* Main container */
.statistics-main {
    flex: 1;
    min-height: calc(100vh - 140px);
    padding: 40px 20px 100px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    position: relative;
    width: 100%;
    max-width: 100vw;
    box-sizing: border-box;
    overflow-x: hidden;
}

.statistics-main::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        0deg,
        rgba(135, 206, 250, 0.03) 0px,
        rgba(135, 206, 250, 0.03) 1px,
        transparent 1px,
        transparent 2px
    );
    pointer-events: none;
}

.statistics-container {
    max-width: 900px;
    width: 100%;
    position: relative;
    box-sizing: border-box;
}

/* Header section */
.statistics-header {
    text-align: center;
    margin-bottom: 40px;
}

.statistics-header h2 {
    font-size: 48px;
    font-weight: bold;
    color: #87CEFA;
    text-shadow: 0 0 10px rgba(135, 206, 250, 0.8),
                 0 0 20px rgba(135, 206, 250, 0.6),
                 0 0 30px rgba(135, 206, 250, 0.4);
    margin: 0;
    letter-spacing: 2px;
    word-wrap: break-word;
}

/* Statistics card */
.statistics-card {
    background: rgba(0, 0, 0, 0.75);
    border: 2px solid #87CEFA;
    border-radius: 12px;
    padding: 40px;
    text-align: center;
    backdrop-filter: blur(10px);
    animation: shadow-move-sky 4s ease-in-out infinite;
    position: relative;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
}

.statistics-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        0deg,
        rgba(135, 206, 250, 0.05) 0px,
        rgba(135, 206, 250, 0.05) 1px,
        transparent 1px,
        transparent 2px
    );
    pointer-events: none;
}

.stat-section {
    margin-bottom: 20px;
    position: relative;
}

/* Stat items */
.stat-item {
    font-size: 18px;
    color: #ffffff;
    font-weight: bold;
    margin: 15px 0;
    text-shadow: 0 0 5px rgba(135, 206, 250, 0.5);
    font-family: Arial, sans-serif;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.loadedstats {
    font-size: 20px;
    color: #87CEFA;
    margin-bottom: 20px;
    animation: fadeOut 1s forwards 4s;
    text-shadow: 0 0 10px rgba(135, 206, 250, 0.8);
    word-wrap: break-word;
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

.user {
    font-size: 22px;
    color: #87CEFA;
    font-weight: bold;
    text-shadow: 0 0 10px rgba(135, 206, 250, 0.8);
    word-wrap: break-word;
}

/* Section titles */
.stat-section-title {
    font-size: 24px;
    color: #87CEFA;
    font-weight: bold;
    margin: 30px 0 20px;
    text-shadow: 0 0 10px rgba(135, 206, 250, 0.8),
                 0 0 20px rgba(135, 206, 250, 0.6);
    letter-spacing: 2px;
    text-transform: uppercase;
    word-wrap: break-word;
}

.stat-category-title {
    font-size: 20px;
    color: #00BFFF;
    font-weight: bold;
    margin: 25px 0 15px;
    text-shadow: 0 0 8px rgba(0, 191, 255, 0.8);
    letter-spacing: 1px;
    word-wrap: break-word;
}

/* Chart container */
.chart-container {
    margin: 30px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Stat lists */
.stat-list {
    margin: 20px 0;
}

.stat-list ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.stat-list ul li {
    padding: 12px 20px;
    margin: 8px 0;
    background: rgba(135, 206, 250, 0.1);
    border-left: 3px solid #87CEFA;
    border-radius: 6px;
    color: #ffffff;
    font-size: 16px;
    text-align: left;
    transition: all 0.3s ease;
}

.stat-list ul li:hover {
    background: rgba(135, 206, 250, 0.2);
    border-left-color: #00BFFF;
    transform: translateX(5px);
    box-shadow: 0 0 15px rgba(135, 206, 250, 0.3);
}

/* Loading state */
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
}

.statsloader {
    font-size: 48px;
    font-weight: bold;
    letter-spacing: 2px;
    font-family: Arial, sans-serif;
    color: #87CEFA;
    animation: smokeOut 1s ease-in-out infinite alternate;
    text-shadow: 0 0 10px rgba(135, 206, 250, 0.8);
}

.statsloader:before {
    content: "loading...";
}

@keyframes smokeOut {
    100% {
        opacity: 0.08;
        filter: blur(5px);
        letter-spacing: 4px;
    }
}

/* Moving shadow animation */
@keyframes shadow-move-sky {
    0% {
        box-shadow: 0 0 0 rgba(135, 206, 250, 0.4);
    }
    25% {
        box-shadow: 10px 10px 10px rgba(135, 206, 250, 0.4);
    }
    50% {
        box-shadow: 20px 10px 0 rgba(135, 206, 250, 0.4);
    }
    75% {
        box-shadow: -10px -10px 10px rgba(135, 206, 250, 0.4);
    }
    100% {
        box-shadow: -10px -10px 0 rgba(135, 206, 250, 0.4);
    }
}

/* Typing cursor animation */
#message {
    overflow: hidden;
    display: inline-block;
}

#message::after {
    content: "|";
    display: inline-block;
    vertical-align: bottom;
    animation: blink 1s infinite, fadeOut 2s forwards 5s;
}

@keyframes blink {
    50% {
        opacity: 0;
    }
}

/* Header and nav */
header {
    background-color: #333;
    padding: 20px;
    padding-bottom: 30px;
    margin: 0 auto;
}

nav ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

nav ul li {
    display: inline-block;
    margin-right: 20px;
}

nav ul li button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

nav ul li:last-child {
    margin-right: 0;
}

nav ul li a,
nav ul li button {
    color: #fff;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
    transition: text-shadow 0.3s ease;
    position: relative;
}

nav ul li a:hover,
nav ul li button:hover {
    color: #87CEFA;
    text-shadow: 1px 1px 2px #87CEFA, 0 0 1em #87CEFA, 0 0 0.2em #87CEFA;
    animation: electric 1s infinite;
}

@keyframes electric {
    0% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
    50% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6), 0 0 20px #87CEFA;
    }
    100% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
}

/* Footer - Handled by EnhancedFooter component */
/* footer {
    height: 60px;
    background-color: #333;
    color: #fff;
    text-align: center;
    font-size: 18px;
    padding-top: 20px;
    margin-top: auto;
} */

/* Responsive design */
@media (max-width: 768px) {
    .statistics-header h2 {
        font-size: 36px;
    }

    .statistics-card {
        padding: 25px;
    }

    .stat-item {
        font-size: 16px;
    }

    .stat-section-title {
        font-size: 20px;
    }

    .stat-category-title {
        font-size: 18px;
    }

    .stat-list ul li {
        font-size: 14px;
        padding: 10px 15px;
    }
}
`;

export default StatisticsStyle;
